'use client'

import Cookies from 'js-cookie'
import { useEffect } from 'react'
import { toast } from 'sonner'

import { COOKIES } from '@/constants'

const CookiesToastChecker = () => {
    useEffect(() => {
        const toastData = Cookies.get(COOKIES.TOAST_MESSAGE)

        if (toastData) {
            const { type, title, description } = JSON.parse(toastData)

            const timer = () => {
                if (type === 'success') {
                    toast.success(title, { description })
                } else if (type === 'error') {
                    toast.error(title, { description })
                } else {
                    toast(title, { description })
                }

                Cookies.remove(COOKIES.TOAST_MESSAGE)
            }

            const timerId = setTimeout(timer, 1000)

            return () => clearTimeout(timerId)
        }
    }, [])

    return null
}

export default CookiesToastChecker
